import { jsx } from "react/jsx-runtime";
import React from "react";
import { string, oneOfType, element } from "prop-types";
const propTypes = {
  /** Content inside of `<option>` */
  name: oneOfType([string, element]),
  /** Value for `<option>` */
  value: string
};
const Option = ({ value, name, ...other }) => {
  return /* @__PURE__ */ jsx("option", { value, ...other, children: name });
};
Option.propTypes = propTypes;
var Option_default = Option;
export {
  Option_default as default
};
